import FlashMessagesTypes from '../flash_message/constants/flash_messages_types';
import { FlashMessageAPI } from 'lecom-api';

export const defaultSuccessFlashMessageObject = {
	type: FlashMessagesTypes.SUCCESS
};

export const defaultErrorFlashMessageObject = {
	type: FlashMessagesTypes.ERROR
};

export const defaultWarningFlashMessageObject = {
	type: FlashMessagesTypes.WARNING
};

export const displaySuccessFlashMessage = (message, flashId) => {
	displayFlashMessage(defaultSuccessFlashMessageObject, message, flashId);
};

export const displaySuccessActionFlashMessage = (actionName, flashId) => {
	const message = Realize.i18n.t(`successResponseMessages.${actionName}`);
	displaySuccessFlashMessage(message, flashId);
};

export const displayWarningFlashMessage = (message, flashId) => {
	displayFlashMessage(defaultWarningFlashMessageObject, message, flashId);
};

export const displayErrorResponseFlashMessage = (flashId, response) => {
	displayErrorFlashMessage(parseErrorResponseMessage(response), flashId);
};

export const displayErrorFlashMessage = (message, flashId) => {
	displayFlashMessage(defaultErrorFlashMessageObject, message, flashId);
};

export const displayFlashMessage = (defaults, message, flashId) => {
	let flashAPI = FlashMessageAPI.flash(flashId);
	flashAPI.addMessage(Object.assign({ message: message }, defaults));
};

export const parseErrorResponseMessage = (response, errorCodePrefix) => {
	const responseEntity = response.entity;

	if(!!responseEntity && responseEntity.errors)
		return parseResponseBodyErrors(responseEntity.errors, errorCodePrefix);

	return parseErrorMessage(response)
};

const parseErrorMessage = (response) => {
	let responseMessage = response.error || response.message;
	let i18nMessage = Realize.i18n.t(responseMessage) || responseMessage;
	if (i18nMessage) {
		return i18nMessage;;
	}
	return response.status ? (`${response.status.code}: ${response.status.text}`) : response;
};

const parseResponseBodyErrors = (errors, errorCodePrefix) => {
	return errors.map((error) => {
		return parseResponseBodyErrorMessage(error, errorCodePrefix);
	});
};

const parseResponseBodyErrorMessage = (error, errorCodePrefix) => {
	const { code, message } = error;

	if(!code) {
		return message || Realize.i18n.t('form.errors.unknown_error');
	}

	let parsedMessage;
	try {
		parsedMessage = parseLocalizedErrorMessage(error.code, errorCodePrefix);
	} catch(err) {
		parsedMessage = message;
	}

	if(code === 'invalid_text_value_size'){
		let invalidSizeMessage = Realize.i18n.t('form.invalid_text_value_size');
		return `${message}: ${invalidSizeMessage}`
	}

	let msgError = error.message.includes('500');
	if(msgError === true && code === 'error'){
		return Realize.i18n.t('form.errorExecuteAction');
	} else if(code === 'error') {
		return Realize.i18n.t('form.errorPossibleExecuteAction');
	}

	return !!parsedMessage
	? `${parsedMessage}`
	: code;
	//(${code})
};

const parseLocalizedErrorMessage = (code, errorCodePrefix) => {
	try {
		return Realize.i18n.t(`${errorCodePrefix}.${code}`, true);
	} catch(err) {
		return Realize.i18n.t(`form.errors.${code}`, true);
	}
};


export const ResponseHandler = {
	displayWarningFlashMessage,
	defaultSuccessFlashMessageObject,
	defaultErrorFlashMessageObject,
	displaySuccessFlashMessage,
	displaySuccessActionFlashMessage,
	displayErrorResponseFlashMessage,
	displayErrorFlashMessage,
	displayFlashMessage,
	parseErrorResponseMessage
};

export default ResponseHandler;
